import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { ClassDurationsDataService, ClassDurationsColumnsService } from '../../../services';
import { ClassDuration, ClassDurationsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-class-duration-details',
  templateUrl: './class-duration-details.component.html',
  styleUrls: ['./class-duration-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ClassDurationDetailsComponent implements OnInit, OnDestroy {

  public classDuration: ClassDuration = {};
  public classDurations: ClassDuration[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private classDurationsDataService: ClassDurationsDataService,
    private classDurationsColumnsService: ClassDurationsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Class Duration - Details');
        this.getClassDuration(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.classDuration !== 'undefined') {
      this.classDuration = this.dynamicDialogConfig.data.classDuration;
    }
    this.columns = this.classDurationsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getClassDuration(id: number): void {
    this.isLoading = true;
    this.classDurationsDataService.getClassDuration(id).subscribe((response: ClassDuration|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.classDuration = response;
      }
    });
  }

  list() {
    this.router.navigate(['/class-durations']);
  }

  add() {
    this.router.navigate(['/class-durations/add']);
  }

  edit() {
    this.router.navigate(['/class-durations/edit/' + this.classDuration.id]);
  }

}
@Component({
  selector: 'app-class-duration-details',
  templateUrl: './class-duration-details.component.html',
  styleUrls: ['./class-duration-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogClassDurationDetailsComponent extends ClassDurationDetailsComponent {
}

